var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
      'plv-watch__status':true,
      [_vm.statusClass]:true,
      'mobile':_vm.isMobile
    }})
}
var staticRenderFns = []

export { render, staticRenderFns }